import { motion } from 'framer-motion';
import Button from '@/components/ui/Button';

const ease = [0.22, 1, 0.36, 1] as const;

interface HeroProps {
  onOpenWaitlist: (source: 'hero_cta') => void;
}

export default function Hero({ onOpenWaitlist }: HeroProps) {
  return (
    <section id="top" className="relative bg-cream">
      <div className="mx-auto w-full max-w-6xl px-6 md:px-8 lg:px-12 pt-20 pb-32 md:pt-28 md:pb-40">
        <div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, ease }}
            className="flex items-center gap-3 mb-10"
          >
            <span className="w-10 h-px bg-primary/60" />
            <span className="font-sans text-xs text-text-secondary">
              For the USCIS naturalization interview
            </span>
          </motion.div>

          <h1 className="font-display text-text-primary leading-[1.02] text-[44px] sm:text-5xl md:text-[72px] lg:text-[88px] xl:text-[96px] tracking-[-0.01em] mb-8">
            <motion.span
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.05, ease }}
              className="block font-light"
            >
              Nail 20 questions the way you answer your{' '}
              <span className="relative inline-block">
                <span className="italic font-light">birthday</span>
                <motion.span
                  aria-hidden
                  initial={{ scaleX: 0 }}
                  animate={{ scaleX: 1 }}
                  transition={{ duration: 0.7, delay: 0.55, ease }}
                  style={{ transformOrigin: 'left' }}
                  className="absolute left-0 right-0 -bottom-1 h-[2px] bg-primary/70"
                />
              </span>
            </motion.span>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.32, ease }}
            className="font-sans text-lg md:text-xl text-text-secondary max-w-[44ch] mb-10 leading-relaxed"
          >
            Practice with an AI USCIS officer. All 128 civics questions,
            voice-graded.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.42, ease }}
          >
            <Button onClick={() => onOpenWaitlist('hero_cta')}>
              Notify me when it's ready
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
